"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _asyncResource = _interopRequireDefault(require("ContentData/reducers/helpers/asyncResource"));

var _default = _asyncResource.default;
exports.default = _default;
module.exports = exports.default;